<template>
  <div class="docker-server">
    <iframe name="iframeChild" id="iframeChild" v-bind:src="getPageUrl"
            frameborder="0" scrolling="auto" ref="iframeDom">
    </iframe>
  </div>
</template>

<script>
  import request from '../../api/nesting';

  export default {
    data() {
      return {
        getPageUrl: ''
      };
    },
    mounted() {
      request.getGsnPageUrlInfo({
        gsnParam: 'toInvoice'
      }).then(res => {
        if (res.status) {
          this.getPageUrl = res.data.gsnReturnUrl;
        }
      });
    }
  };
</script>

<style scoped>
  #iframeChild {
    width: 100%;
    height: calc(100vh - 125px);
  }
</style>